import { useEffect, useRef, useState } from "react";
import ConfigurationStore from "../../stores/ConfigurationStore";

function Site(props) {
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const form = useRef(null);

  const [client_id, setClientId] = useState(null);

  useEffect(() => {
    ConfigurationStore.getClients();
    let id = props.match.params.id;
    if (id) {
      ConfigurationStore.getSite(id).then((result) => {
        Object.keys(result).map((key) => {
          if (document.getElementsByName(key).length > 0) {
            document.getElementsByName(key)[0].value = result[key]
              ? result[key]
              : "";
          }
          if (key === "client_id") {
            setClientId(result[key]);
          }
        });
      });
      setEditMode(true);
    }
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData(form.current);

    let data = {};
    for (var key of formData.keys()) {
      data[key] = formData.get(key);
    }

    if (editMode) {
      data["client_id"] = client_id;
      ConfigurationStore.updateSite(props.match.params.id, data)
        .then(() => {
          setLoading(false);
          props.history.push("/sites");
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      ConfigurationStore.createSite(data)
        .then(() => {
          setLoading(false);
          props.history.push("/sites");
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };

  let { clients } = ConfigurationStore;
  return (
    <div className="add-element">
      <div className="box">
        <h2>{editMode ? "Edit" : "Add"} Site</h2>
        <div className="form-block">
          <form ref={form} onSubmit={(e) => onSubmit(e)}>
            <div className="input-box">
              <label>Site name</label>
              <input
                required
                name="site_name"
                type="text"
                className="form-control"
              />
            </div>
            <div className="input-box">
              <label>Hubspot Site ID</label>
              <input
                required
                name="hubspot_site_id"
                type="text"
                className="form-control"
              />
            </div>
            <div className="input-box">
              <label>Application Name</label>
              <input name="appName" type="text" className="form-control" />
            </div>
            <div className="input-box">
              <label>App Name</label>
              <input name="app_name" type="text" className="form-control" />
            </div>
            <div className="input-box">
              <label>Application Code</label>
              <input
                required
                name="application_code"
                type="text"
                className="form-control"
              />
            </div>
            <div className="input-box">
              <label>Customer Name</label>
              <input
                name="customer_name"
                type="text"
                className="form-control"
              />
            </div>
            <div className="input-box">
              <label>Activator Type</label>
              <input name="type" type="text" className="form-control" />
            </div>
            <div className="input-box">
              <label>Customer ID</label>
              <input name="customer_id" type="text" className="form-control" />
            </div>

            <div className="input-box">
              <label>Select Client</label>
              <select
                disabled={editMode}
                name="client_id"
                className="form-control"
                value={client_id}
              >
                <option value="">Select client</option>
                {clients &&
                  clients.map((c) => {
                    return <option value={c._id}>{c.name}</option>;
                  })}
              </select>
            </div>

            <div className="input-box">
              <label>Activator Params</label>
              <input
                name="activator_params"
                type="text"
                className="form-control"
              />
            </div>
            <div className="input-box">
              <label>activators_online</label>
              <input
                name="act_online_params"
                type="text"
                className="form-control"
              />
            </div>
            <div className="input-box">
              <label>gateways</label>
              <input
                name="gateways_params"
                type="text"
                className="form-control"
              />
            </div>
            <div className="input-box">
              <label>gateways_online</label>
              <input
                name="gat_online_params"
                type="text"
                className="form-control"
              />
            </div>
            <div className="input-box">
              <label>attach_failures</label>
              <input
                name="atch_failure_params"
                type="text"
                className="form-control"
              />
            </div>
            <div className="input-box">
              <label>attach_rate_rolling_monthly</label>
              <input
                name="atch_rol_monthly_params"
                type="text"
                className="form-control"
              />
            </div>
            <div className="input-box">
              <label>brownouts</label>
              <input
                name="brownouts_params"
                type="text"
                className="form-control"
              />
            </div>
            <div className="input-box">
              <label>battery_health</label>
              <input
                name="bat_health_params"
                type="text"
                className="form-control"
              />
            </div>
            <div className="input-box">
              <label>trackers_total_inventory</label>
              <input
                name="trckr_inv_params"
                type="text"
                className="form-control"
              />
            </div>
            <div className="input-box">
              <label>Unresponsive Count Params</label>
              <input
                name="unresp_cnt_params"
                type="text"
                className="form-control"
              />
            </div>
            <div className="input-box">
              <label>Bad Status Params</label>
              <input
                name="bad_status_params"
                type="text"
                className="form-control"
              />
            </div>

            <div className="btn-box">
              <button
                disabled={loading}
                htmlType="submit"
                className="primarybtn"
              >
                {loading ? `Please wait...` : editMode ? "Update" : "Add"}
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="box desc-box">
        <p>
          Duis gravida vehicula dui, non gravida ex tempus in. Aliquam in diam
          eu urna varius cursus. Duis ut auctor purus, non consequat nisl.
          Vestibulum ante ipsum primis in faucibus orci luctus et ultrices
          posuere cubilia curae; Maecenas lorem nibh.
        </p>
      </div>
    </div>
  );
}

export default Site;
